import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=310c61f9"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"
import style0 from "./Todo.vue?vue&type=style&index=0&id=310c61f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports